
























































































































































































































































// TODO: Add validations for all fields

import { FormsApi, PatientApi } from "@/api";
import stateMixin from "@/mixins/state";
import { toLocalDateString } from "@/util/date";
import moment from "moment";

import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
// Import the File Type Validation plugin
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
// import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
// import FilePondPluginImagePreview from "filepond-plugin-image-preview";

const FilePond = vueFilePond(FilePondPluginFileValidateType);

const who = [
  {
    text: "Apotheek",
    value: "Pharmacy"
  },
  {
    text: "Verpleegkundig personeel",
    value: "Institution"
  },
  {
    text: "Patient",
    value: "Patient"
  }
];

const subjects = [
  {
    text: "Ontbreken medicatie",
    value: "MissingDrug"
  },
  {
    text: "Ontbreken zakje",
    value: "MissingBag"
  },
  {
    text: "Ontbreken rollen",
    value: "MissingScroll"
  },
  {
    text: "Ontbreken toedienlijst",
    value: "MissingTdl"
  },
  {
    text: "Ontbreken adresetiketten",
    value: "MissingAddress"
  },
  {
    text: "Verkeerde medicatie",
    value: "WrongDrugs"
  },
  {
    text: "Verkeerde rol",
    value: "WrongScroll"
  },
  {
    text: "Verkeerd bezorgde bak",
    value: "WrongCrate"
  },
  {
    text: "Verkeerde toedienlijst",
    value: "WrongTdl"
  },
  {
    text: "Verkeerd adres etiket",
    value: "WrongAddress"
  },
  {
    text: "Verkeerde verpakking",
    value: "WrongPackaging"
  },
  {
    text: "Te veel medicatie",
    value: "TooManyDrugs"
  },
  {
    text: "Te veel rollen",
    value: "TooManyScrolls"
  },
  {
    text: "Beschadigde medicatie",
    value: "DamagedDrugs"
  },
  {
    text: "Beschadigd zakje",
    value: "DamagedBag"
  },
  {
    text: "Beschadigde rollen",
    value: "DamagedScroll"
  },
  {
    text: "Beschadigde verpakking",
    value: "DamagedPackaging"
  },
  {
    text: "Te laat",
    value: "Late"
  },
  {
    text: "Niet ontvangen",
    value: "Missing"
  }
];

export default {
  data() {
    return {
      valid: true,
      toLocalDateString,
      subjects,
      who,

      myFiles: null,

      dateTime: {
        date: null,
        time: null
      },

      errors: {},

      filePond: {
        files: null,
        server: {
          url: process.env.VUE_APP_API,
          process: {
            url: "/api/portal/File/UploadFile",
            method: "POST",
            headers: {
              Authorization: ""
            }
          }
        }
      },

      autocomplete: {
        entries: [],
        isLoading: false,
        model: null,
        search: null,
        error: false
      },

      fields: {
        department: null,
        drugName: null,
        generalAdditionalInformation: null,
        imageGuid: null,
        imperfectionLocation: null,
        imperfectionType: null,
        swallowDateTime: null,
        takenActions: null,
        feedBackOption: "Email",
        contactInfo: null
      },

      rules: {
        // date: [v => !!v || "Slikdatum is verplicht"],
        department: [v => !!v || "Afdeling is verplicht"],
        drugName: [v => !!v || "Naam geneesmiddel is verplicht"],
        drugStrength: [v => !!v || "Sterkte is verplicht"],
        drugAmount: [v => !!v || "Aantal is verplicht"],
        generalAdditionalInformation: [
          v => !!v || "Extra informatie is verplicht"
        ],
        imperfectionLocation: [v => !!v || "Ontdekker is verplicht"],
        imperfectionType: [v => !!v || "Klachttype is verplicht"],
        patient: [v => !!v || "Patient is verplicht"],
        // time: [v => !!v || "Sliktijd is verplicht"],
        takenActions: [v => !!v || "Ondernomen acties is verplicht"],
        contactInfo: [v => !!v || "Dit veld is verplicht"]
      },

      startDateMenu: null,
      startTimeMenu: null,
      sendDateMenu: null,
      receiveDateMenu: null
    };
  },
  name: "ReportImperfection",
  mixins: [stateMixin],
  components: {
    FilePond
  },
  methods: {
    submit: async function() {
      if (this.valid) {
        this.setState(this.states.LOADING);
        const api = new FormsApi();
        try {
          const result = await api.formsReportImperfection({
            ...this.fields,
            patientId: this.autocomplete.model.patientId,
            swallowDate: this.swallowDateTime
          });
          this.setState(this.states.COMPLETED);

          (this.$refs.form as HTMLFormElement).reset();
          this.$refs.pond.removeFiles();
        } catch (e) {
          this.errors = {};
          Object.keys(e.response.data.errors).forEach(item => {
            this.errors[item.toLowerCase()] = e.response.data.errors[item];
          });
          this.setState(this.states.ERROR);
        }
      }
    },
    handleFilePondInit() {
      this.filePond.server.process.headers[
        "Authorization"
      ] = `Bearer ${this.$store.getters["auth/getAuth"].accessToken}`;
    },
    processUploadedFile(err, file) {
      this.fields.imageGuid = file.serverId;
    },
    getErrors(property: string) {
      const key = property.toLowerCase();
      return this.errors[key] || this.errors[`$.${key}`] || [];
    },
    resetErrors(property: string) {
      const key = property.toLowerCase();
      this.$delete(this.errors, key);
    }
  },
  computed: {
    currentDate() {
      let date = new Date(Date.now());
      return `${date.getFullYear()}-${`0${date.getMonth() + 1}`.slice(
        -2
      )}-${date.getDate()}`;
    },
    swallowDateTime() {
      let date = "";
      if (this.dateTime.date && this.dateTime.time) {
        date = new Date(`${this.dateTime.date} ${this.dateTime.time}`);
      }
      // return date;
      return date != "" ? moment(date).format() : "";
    }
  },
  watch: {
    "autocomplete.search": _.debounce(function(val) {
      if (!val) {
        return;
      }
      if (val.length < 2) {
        return;
      }

      let self = this;
      this.autocomplete.isLoading = true;
      this.autocomplete.error = true;

      const api = new PatientApi();
      api
        .patientSearchPatients({
          filter: val
        })
        .then(function(res) {
          self.autocomplete.entries = res.data;
          self.autocomplete.isLoading = false;
          self.autocomplete.error = false;
        })
        .catch(function(err) {
          self.autocomplete.isLoading = false;
          self.autocomplete.error = true;
        });
    }, 1000)
  }
};
